import { Directive, HostListener, ElementRef, Input, OnDestroy } from '@angular/core';
import { TooltipService } from './tooltip.service';
import { UtilityService } from '@irb-common/services/utility.service';

@Directive({ selector: '[tooltip]',standalone: false })
export class TooltipDirective implements OnDestroy {
  @Input() tooltipTitle: string;
  @Input() tooltipPosition: string = "bottom";
  @Input() tooltipRequiresTruncation: boolean = false;
  @Input() tooltipVerticalOffset: number = 12;
  @Input() tooltipHorizontalOffset: number = 12;
  @Input() tooltipWidth: number;
  @Input() tooltipClass: string;
  @Input() tooltipRequiresSafe: boolean = false;
  private id: string;

  constructor(private element: ElementRef, private tooltipService: TooltipService, private util: UtilityService) {}
  
  @HostListener('mouseenter', ['$event'])
  onMouseEnter(e: Event): void {
    this.create(e);
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.destroy();
  }

  @HostListener('keyup', ['$event'])
  onKeyup(e: Event): void {
    this.create(e);
  }
  
  ngOnDestroy(): void {
    this.destroy();
  }

  destroy(): void {
    this.tooltipService.remove();
  }
  
  create(e: Event) {
    let encoded = false;
    const tgt: any = e?.target;
    // https://jira.associatesys.local/browse/IRBLMS-83
    // XSS like <img src=a onerror=alert(123)>
    if (this.tooltipRequiresSafe && this.tooltipTitle && this.tooltipRequiresTruncation) {
      let isHTML = RegExp.prototype.test.bind(/(<([^>]+)>)/i);
      if (tgt.tagName === 'INPUT' || tgt.tagName === 'TEXTAREA') {
        if (isHTML(tgt.value)) {
            tgt.value = encodeURI(tgt.value);
            encoded = true;
        }
      }
    }

    if(this.tooltipRequiresTruncation && !this.util.hasTruncation(e.target as HTMLElement)) {
      return;
    }
    if (tgt && encoded) {
      tgt.value = decodeURI(tgt.value);
    }

    this.id = (new Date()).getTime().toString();

    const d = { 
      id: this.id, 
      ref: this.element, 
      title: this.tooltipTitle,
      position: this.tooltipPosition,
      event: e,
      useTruncationParent: this.tooltipRequiresTruncation,
      verticalOffset: this.tooltipVerticalOffset,
      horizontalOffset: this.tooltipHorizontalOffset,
      _width: this.tooltipWidth,
      class: this.tooltipClass
    };
    
    if(d.title && d.title.length > 0) { 
      this.tooltipService.add(d);
    }
  }

}
